import { Clock } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

// Times at 15-minute increments, "h:mm AM/PM".
export const TIME_OPTIONS = (() => {
  const out = [];
  for (let h = 0; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {
      const ap = h < 12 ? "AM" : "PM";
      const hh = h % 12 || 12;
      out.push(`${hh}:${String(m).padStart(2, "0")} ${ap}`);
    }
  }
  return out;
})();

export const TimeSelect = ({ value, onChange, placeholder = "Pick time", testid, className = "" }) => {
  // Keep an off-grid existing value selectable so it's never lost.
  const opts = value && !TIME_OPTIONS.includes(value) ? [value, ...TIME_OPTIONS] : TIME_OPTIONS;
  return (
    <Select value={value || ""} onValueChange={onChange}>
      <SelectTrigger className={className} data-testid={testid}>
        <span className="flex min-w-0 items-center gap-1.5">
          <Clock className="h-3.5 w-3.5 shrink-0 opacity-60" />
          <SelectValue placeholder={placeholder} />
        </span>
      </SelectTrigger>
      <SelectContent className="max-h-64 border-zinc-800 bg-zinc-950">
        {opts.map((t) => (
          <SelectItem key={t} value={t}>{t}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
